// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3fqvp","content":"GlobalSearch_content__1KhGe"};